import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { OverlayLoader } from "components/core";
import ECardList from "components/Dashboard/ECardList";
import http from "services/httpService";
import { SideNav, SideNavContent } from "components";
import { HomeWrapper } from "components/CdBalance/style";
import HeaderDasNew from "components/core/headerDasNew";
import { ECardPreviewMain } from "pages/CareDashboard/styles";
import BaseBreadcrumbs from "components/core/BaseBreadcrumbs";

const ECardView = () => {
  // getting company name from local storage
  const company_name = localStorage.getItem("company_name");

  // getting state to extract employeeId
  const { empId } = useParams();
  // storing member policy details
  const [memberDetails, setMemberDetails] = useState({});
  // loading flag to display loader
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      // fetching e-cards info
      await fetchECards();
    })();
  }, []);

  const renderECards = () => {
    // sorting products in GMC -> GPA -> GTL order
    const products = Object.keys(memberDetails).sort((a, b) => {
      if (a.slice(0, 3) < b.slice(0, 3)) {
        return -1;
      } else if (a.slice(0, 3) > b.slice(0, 3)) {
        return 1;
      } else {
        return a.length < b.length ? -1 : 1;
      }
    });
    // returning JSX list of e-card list
    return (
      <ECardPreviewMain>
        {products.map((prod, index) => (
          <ECardList
            key={index.toString()}
            abbr={prod}
            members={memberDetails[prod]}
          />
        ))}
      </ECardPreviewMain>
    );
  };

  // to fetch e-cards
  const fetchECards = async () => {
    // sending payload containing employeeId
    const payload = {
      employee_id: empId,
    };
    try {
      const { data } = await http.post(
        "business/fetch_ecard_details/",
        payload
      );
      // saving member details
      setMemberDetails(data);
    } catch (_) {
      alert("Some error has occured!");
    } finally {
      // hiding loader using flag
      setLoading(false);
    }
  };
  const crumbs = useMemo(() => {
    return [
      {
        name: "Employee MIS",
        path: "/v1/employee-mis"
      },
      {
        name: "E-Cards",
        active: true
      },
    ]
  }, [])
  if (loading) return <OverlayLoader />;
  return <section>
    <BaseBreadcrumbs breadcrumbs={crumbs} />
    {renderECards()}
    </section>;
};

export default ECardView;
